import React from 'react';
import Swal from 'sweetalert2';
import { snakeCaseToTitleCase } from '../../../common/utils/api_utils';
import moment from 'moment';
import axios from 'axios';
import cookie from 'react-cookies';
import CustomLoader from '../../common/CustomLoader';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import { localStorageKey } from '../../../common/utils/constant';

export default function DbExportList({
  projectId,
  DbExportRequestList,
  deleteDbExportRequest,
  saveDbExportRequestPending,
  loadDbExportRequestListPending,
  deleteFlag,
  version,
}) {
  const isExportList = DbExportRequestList && DbExportRequestList.length > 0;
  const fields = isExportList && DbExportRequestList[DbExportRequestList.length - 1];

  const handleDelete = (id, projectId) => {
    const preConfirm = () => {
      return deleteDbExportRequest({ id, projectId, version });
    };
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const downloadDbDump = (id) => {
    const environment = localStorage.getItem(localStorageKey.ENVIRONMENT);
    const headers = {
      'x-project-id': projectId,
      token: `Bearer ${cookie.load('token')}`,
    };
    if (environment) {
      headers['x-project-env'] = environment.toLowerCase();
    }
    axios({
      url: `${process.env.REACT_APP_BUILDER_ENGINE}db-export/downloadDbDump/${id}`,
      method: 'GET',
      responseType: 'blob', // important
      headers,
    }).then((response) => {
      const { data, headers } = response;
      const contentDisposition = headers['content-disposition'];
      const fileName = contentDisposition.substring(
        contentDisposition.indexOf('filename=') + 9,
        contentDisposition.length,
      );

      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);
    });
  };

  if (!isExportList) return <div className="alert">No Code Export Request</div>;
  if (saveDbExportRequestPending)
    return <CustomLoader loading={saveDbExportRequestPending} size="20px" color="#303453" />;

  return (
    <table className="table table-bordered table-word-break">
      <thead>
        <tr>
          <th>#</th>
          <th>Project Name</th>
          <th>Name</th>
          <th>Request Initiated</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {isExportList &&
          DbExportRequestList.map((listItem, index) => (
            <tr key={listItem._id}>
              <td>{index + 1}</td>
              <td>{listItem.projectName}</td>
              <td>{listItem.displayName}</td>
              <td>{moment(listItem.createdAt).format('Do MMM YYYY hh:mm:ss A')}</td>
              <td>{snakeCaseToTitleCase(listItem.status)}</td>
              <td>
                <button
                  type="button"
                  className="btn btn-theme-submit btn-xs"
                  title="Download"
                  disabled={listItem.status !== 'EXPORTED'}
                  onClick={() => {
                    downloadDbDump(listItem.uuid);
                  }}
                >
                  <i className="wb webconnect-download"></i>&nbsp;Download
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-theme-delete btn-xs"
                  style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
                  title="Delete Item"
                  onClick={() => {
                    deleteFlag ? handleDelete(listItem.uuid, listItem.projectId) : undefined;
                  }}
                >
                  <i className="wb webconnect-trash-regular" />
                  {deleteFlag ? null : (
                    <>
                      &nbsp;
                      <TooltipInfo
                        title={description}
                        headerText={`Permission Disabled!`}
                        showHeader={true}
                        showArrow={true}
                      />
                    </>
                  )}
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
